import { jsx as _jsx } from "react/jsx-runtime";
import { DirectoryPanel as KitDirectoryPanel, } from '@unity/ui-kit/directory-panel';
import '@unity/ui-kit/directory-panel.css';
export function DirectoryPanel(props) {
    return _jsx(KitDirectoryPanel, { ...props });
}
